import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import {mask} from 'vue-the-mask'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  title: 'Buscar Corretor',
  name: 'UserSearchCard',
  mixins: [ActionsForm, ExpenseMixin],
  components: {AutocompleteZ},
  props: {
    showCreci: {
      type: Boolean,
      default: true
    },
    searchCustomer: {
      type: Boolean,
      default: false
    },
    searchByCliente: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataSearch: {
        nome: '',
        cpf: '',
        rg: '',
        usuarioId: '',
        creci: '',
        dataCadastroInicio: '',
        dataCadastroFim: '',
        statusSelecionado: '',
        usuario: {
          nome: '',
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      cpfField: '',
      userStatus: [
        {value: null, text: 'Todos os status'},
        {value: 0, text: 'Ativo'},
        {value: 1, text: 'Inativo'},
        {value: 2, text: 'Ag. Aprovação'}
      ]
    }
  },
  methods: {
    Clear () {
      localStoreHelper.gestao.cliente(null)
      this.cpfField = ''
      Object.keys(this.dataSearch).forEach(prop => {
        if (prop === 'usuario' && this.dataSearch[prop] !== null) {
          this.dataSearch[prop].value = null
        } else {
          this.dataSearch[prop] = ''
        }
      })
      this.$emit('dataSearch', this.dataSearch, false)
      this.$refs.ClienteTypeahead.clear()
    },
    Search () {
      var today = new Date()
      if (this.dataSearch.dataCadastroInicio !== '' && this.dataSearch.dataCadastroFim === '') {
        this.dataSearch.dataCadastroFim = today
      }
      this.dataSearch.cpf = this.cpfField.replace(/[().-]/gm, '')
      this.dataSearch.rg = this.dataSearch.rg.replace(/[().-]/gm, '')
      this.dataSearch.usuarioid = this.dataSearch.usuario !== null ? this.dataSearch.usuario.value : null
      this.$emit('dataSearch', this.dataSearch, true)
      localStoreHelper.gestao.cliente(this.dataSearch)
    }
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/UserSearchCard/UserSearchCard.js